import { DrawerState } from './globalDrawer';
import { genericAtom } from '../jotai';

const subDrawerStateDefault: DrawerState = {
    isOpen: false,
    titleTransCode: undefined,
    content: null,
    footer: null,
    subtitle: undefined,
};

export const subDrawerState = genericAtom<DrawerState | null>(
    subDrawerStateDefault
);
